<template>
  <div>
    <div style="text-align:right;"><h3>This Year's Appointments</h3></div>
    <iframe class="airtable-embed" src="https://airtable.com/embed/shrQECpylDKRCoWhF?backgroundColor=blue&viewControls=on" frameborder="0" onmousewheel="" width="100%" height="600" style="background: #333; border: 1px solid #333;"></iframe>
  </div>
</template>

<script>
export default {
  data() {
    return {}
  },
  components: {},
  computed: {},
  methods: {},
  mounted() {}
}
</script>

<style>

</style>
